export const getScrollPadding = () => {
    const paddingPx = window.getComputedStyle(document.documentElement)['scrollPaddingTop'];

    if (!paddingPx) {
        return 0;
    }

    const result = parseInt(paddingPx.replace('px', ''), 10)
    return result;
}